import { CdkStepper } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-account-stepper',
    templateUrl: './account-stepper.component.html',
    styleUrls: ['./account-stepper.component.scss'],
    providers: [{ provide: CdkStepper, useExisting: AccountStepperComponent }],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule]
})
export class AccountStepperComponent extends CdkStepper {
    selectStepByIndex(index: number): void {
        this.selectedIndex = index;
    }
}
